

export let decimals = (number, decimals = 2) => {
    if (! isNaN(number) && decimals > 0) {
        return parseFloat(Number(number)).toFixed(decimals)
    }

    return number
}

export let keep2Decimals = (number) => {
    return decimals(number)
}

export function formatNum(num) {
    if (isNaN(num)) {
        return num
    }

    if ((num + '').length > 4) {
        let t1 = parseInt(num / 1e4)
        let t2 = Math.round((num % 1e4) / 1e3)
        if (t2 != 0) {
            t1 += '.' + (t2 >= 10 ? parseInt(t2 / 10) : t2)
        }
        t1 += '万'
        return t1
    } else {
        return num + ''
    }
}

export function formatNumFixed2(num) {
    if (isNaN(num)) {
        return num
    }
    if (num < 10000) {
        return num.toFixed(2)
    }
    return (num / 10000).toFixed(2) + '万'
}